// extracted by mini-css-extract-plugin
export default {"statsContainer":"style_statsContainer__tElT2"};